import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from '../../token/interceptor';


//************* GENERAL  ***************************/
import { TipoConfiguracionService } from '../tipoConfiguracion/tipoConfiguracion.service';
import { ConfiguracionSistemaService } from '../configuracionSistema/configuracionSistema.service';
import { ConsultasUtilGenerales } from './consultasUtilGenerales/consultasUtilGenerales';
import { SecuencialDocumentoService } from '../secuencialDocumento/secuencialDocumento.service';
import { ArchivosAplicacionService } from '../archivoAplicacion/archivoAplicacionSistema.service';
import { CatalogoAplicacionService } from '../catalogoAplicacion/catalogoAplicacion.service';
import { TipoDocumentoService } from '../tipoDocumento/tipoDocumento.service';


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: []
})
export class SharedGeneralModule {
  static forRoot(): ModuleWithProviders<SharedGeneralModule> {
    return {
      ngModule: SharedGeneralModule,
      providers: [
        TipoConfiguracionService, ConfiguracionSistemaService, ConsultasUtilGenerales,
        SecuencialDocumentoService, ArchivosAplicacionService, CatalogoAplicacionService,
        TipoDocumentoService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: Interceptor,
          multi: true
        }]
    };
  }
}
